import { render, staticRenderFns } from "./DocumentPdf.vue?vue&type=template&id=57b8adc6&scoped=true"
import script from "./DocumentPdf.vue?vue&type=script&lang=js"
export * from "./DocumentPdf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b8adc6",
  null
  
)

export default component.exports